import { render, staticRenderFns } from "./servicePopulationSx.vue?vue&type=template&id=e7388c2e&"
import script from "./servicePopulationSx.vue?vue&type=script&lang=js&"
export * from "./servicePopulationSx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports